module.exports = __webpack_public_path__ + "static/img/AR1.327915b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/AR1.jpg
// module id = ub9M
// module chunks = 12